import type { VoidFunctionComponent } from 'react';
import * as moment from 'moment';
import type { PortalToken } from '../../../../shared/publicPortal/types';
import { CopiableText } from '../../generic';
import Tooltip from '../../generic/Tooltip';
import styles from './Cell.module.less';

const DateCell: VoidFunctionComponent<{ date: Date }> = ({ date }) => <span>{moment(date).format('M/DD/YY')}</span>;

export const ExpirationCell: VoidFunctionComponent<{ original: PortalToken }> = ({ original }) =>
  original.expiration ? <DateCell date={original.expiration} /> : <span>Never</span>;

export const LastUsedCell: VoidFunctionComponent<{ original: PortalToken }> = ({ original }) => (
  <span>{original.lastUsed ? moment(original.lastUsed).format('M/DD/YY h:mma') : 'N/A'}</span>
);

export const CreatedCell: VoidFunctionComponent<{ original: PortalToken }> = ({ original }) => (
  <DateCell date={original.createdAt} />
);

export const TokenCell: VoidFunctionComponent<{ original: PortalToken }> = ({ original }) => (
  <CopiableText
    id={original.id.toString()}
    name="token"
    value={original.token}
    hideSensitiveValue
    showCopyIcon={false}
    variant="primary"
  />
);

export const TokenNameCell: VoidFunctionComponent<{ original: PortalToken }> = ({ original }) => (
  <Tooltip id={`token-name-${original.id}`} tooltip={original.name}>
    <div className={styles.tokenName}>{original.name}</div>
  </Tooltip>
);
